"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPluginsByName = exports.filterPluginsByTypes = exports.filterPluginsByType = void 0;
const filterPluginsByType = (plugins, typeFilter) => {
    return plugins.filter((plugin) => plugin.type === typeFilter);
};
exports.filterPluginsByType = filterPluginsByType;
const filterPluginsByTypes = (plugins, typesFilter, invertResult = false //When true, reuturns only plugins that do not match the typesFilter
) => {
    if (invertResult) {
        return plugins.filter((plugin) => !typesFilter.includes(plugin.type));
    }
    return plugins.filter((plugin) => typesFilter.includes(plugin.type));
};
exports.filterPluginsByTypes = filterPluginsByTypes;
const filterPluginsByName = (plugins, nameFilter) => {
    return plugins.filter((plugin) => plugin.name === nameFilter);
};
exports.filterPluginsByName = filterPluginsByName;
